import useReportMapper from './useReportMapper'

function IrishLifeReport({ formCode, data }) {

    const reportMapper = useReportMapper()

    const Report = reportMapper.getReportByCode(formCode)

    return (
        <Report data={data} />
    )
}

export default IrishLifeReport